namespace e5 {
    export interface JsonLoaderOptions extends AjaxLoaderOptions {

    }

    class JsonLoader<Data> extends AbstractAjaxLoader<Data, JsonLoaderOptions>{
        protected defaultOptions(): SvgLoaderOptions {
            return {
                decoder: "json",
                encoder: "json"
            }
        }
    }

    export interface LoaderOptionsMap {
        "json": JsonLoaderOptions;
    }

    export interface LoaderMap {
        "json": JsonLoader<any>;
    }

    registerLoader("json", JsonLoader);
}